export default __webpack_public_path__ + "6beb99c70619c0c9eeba6b9db4d68b48.mp3";